import { render, staticRenderFns } from "./WidgetViewPreset.vue?vue&type=template&id=56fa9675&scoped=true&"
import script from "./WidgetViewPreset.vue?vue&type=script&lang=js&"
export * from "./WidgetViewPreset.vue?vue&type=script&lang=js&"
import style0 from "./WidgetViewPreset.vue?vue&type=style&index=0&id=56fa9675&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56fa9675",
  null
  
)

export default component.exports